let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dJqBp")).then(() => parcelRequire('aBX1P'));